const Layout = () => import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");

const Facilities = () => import(/* webpackChunkName: "Home" */ "../views/facilities/Index.vue");
export default [
  {
    path: "/facilities",
    name: "facilities",
    component: Layout,
    meta: {
      title: "会议设施",
      titleEn: "Conference Facilities",
    },
    children: [
      {
        path: "",
        component: Facilities,
      },
    ],
  },
];
